var _defs, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 583.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b2b2b;}.cls-2{stroke-width:18px;}.cls-2,.cls-3{stroke-linecap:round;}.cls-2,.cls-3,.cls-4{fill:none;stroke:#2b2b2b;stroke-miterlimit:10;}.cls-3{stroke-width:16px;}.cls-4{stroke-width:16.26px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M439.89,456.66v56.51c0,17.39-14.09,31.48-31.48,31.48H97.05c-17.39,0-31.48-14.09-31.48-31.48V76.5c0-17.39,14.09-31.48,31.48-31.48h237.89l104.96,99.58v66.84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.14,206.15l5.68,26.94c2.12,2.06,22.12-12.47,26.26-13.33l48.56,48.17-12.92,25.21,26.89,7.47-.09,68.97c-.81,2.38-22.76,7.06-26.85,7.46-2.36,2.49,11.97,21.72,13.03,25.93l-49.02,48.93c-1.79.8-23.02-15.76-25.86-13.02-.4,4.1-5.08,26.04-7.46,26.85l-68.97.09-6.73-26.47c-3.42-2.55-20.7,12.53-25.96,12.5l-47.83-47.86c-1.52-3.04,15.4-24.49,13-26.95l-26.99-5.64-.07-70.16,26.57-7.37c1.07-1.2.36-2.21-.11-3.4-1.53-3.87-13.19-19.46-12.73-21.81l48.22-48.58c3.11-1.55,20.17,12.7,25.21,12.98l7.49-26.87,70.7-.06ZM461.42,224.24h-40.76c-3.26,1.11-4.24,19.06-6.62,22.06-.55.69-14.98,6.62-16.31,6.84-5.71.94-19.22-11.64-21.65-10.54l-28.96,29.28,10.98,19.21-6.67,17.72-22.43,7.09v40.76s22.34,6.34,22.34,6.34c.63.6,6.41,14.78,6.57,16.05.67,5.53-11.78,18.86-10.53,21.64l28.38,27.94,21.13-10.68,16.27,6.93,7.52,23.07,40.76-.17,6.3-22.37,16.21-7.34c5.67.46,17.72,12.38,22.54,10.19,3.58-5.43,25.74-23.12,26.88-27.28,1.19-4.32-9.53-16.04-10.67-21.12,3.42-4.8,4.66-15.71,9.69-18.01,3.08-1.41,19.85-3.86,20.31-5.79l-.55-40.94-21.97-6.14-7.69-17.04c1.25-4.96,12.52-17.29,10.52-21.69l-28.14-27.84-19.19,10.92-17.34-6.22-6.94-22.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.71,262.65c84.28-10.12,117.77,97.74,49.36,137.09-57.33,32.97-124.36-18.08-109.29-82.3,6.27-26.73,32.43-51.48,59.93-54.78ZM430.93,280.62c-67.02,9.06-58.6,118.72,16.44,110.91,71.06-7.39,62.62-121.6-16.44-110.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.19,299.74c59.32-8.62,57.32,81.38.21,72.3-39.28-6.24-38.27-66.78-.21-72.3ZM435.4,317.7c-17.86,3.68-18.14,34.21,2.09,36.75,29.85,3.75,28.74-43.1-2.09-36.75Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.92,
    y1: 198.48,
    x2: 310.8,
    y2: 198.48
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.92,
    y1: 447.95,
    x2: 310.8,
    y2: 447.95
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.92,
    y1: 261.98,
    x2: 268.66,
    y2: 261.98
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.92,
    y1: 322.85,
    x2: 268.66,
    y2: 322.85
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 203.92,
    y1: 386.03,
    x2: 268.66,
    y2: 386.03
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.99,
    y1: 319.97,
    x2: 140.87,
    y2: 336.48
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.99,
    y1: 256.98,
    x2: 140.87,
    y2: 273.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.99,
    y1: 195.39,
    x2: 140.87,
    y2: 211.9
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.99,
    y1: 381.41,
    x2: 140.87,
    y2: 397.92
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 124.99,
    y1: 442.85,
    x2: 140.87,
    y2: 459.36
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 141.14,
    y1: 336.31,
    x2: 168.06,
    y2: 309.39
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 141.24,
    y1: 273.84,
    x2: 168.16,
    y2: 246.91
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 141.14,
    y1: 397.93,
    x2: 168.06,
    y2: 371.01
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 141.14,
    y1: 459.55,
    x2: 168.06,
    y2: 432.62
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 141.03,
    y1: 211.83,
    x2: 167.96,
    y2: 184.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.94,45.03v90.07c0,5.07,4.11,9.18,9.18,9.18h95.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.023d4ed38122a6653c37a6a2f430bedc.svg";
export { ForwardRef as ReactComponent };